import { fetcher } from '@commenda/utils';

import type { IExternalShare } from '../file-share/types';
import { FORM_SHARES_BASE_URL } from './helpers';

export const revokeFormShare = async (
  id: string
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher(`${FORM_SHARES_BASE_URL}/${id}/revoke`, {
    method: 'POST',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to revoke form share link.');
  }

  return await res.json();
};
